import { configureStore } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { TypedUseSelectorHook, useDispatch } from 'react-redux';
import UserReducer from './UserReducer';
import CommonFieldReducer from './CommonFieldsReducer';
import SearchReducer from './SearchReducer';
// import reducers from './index';

export const store = configureStore({
  reducer: {
    user: UserReducer,
    commonFields: CommonFieldReducer,
    searchFilters: SearchReducer,
  },
  //   middleware: (getDefaultMiddleware) =>
  //     getDefaultMiddleware({
  //       immutableCheck: false,
  //     }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
